export default __webpack_public_path__ + "static/media/yellow-giftcard.98193e93.svg";